<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<talent-info :row="row">
			<tooltip
				class="expire"
				v-if="!row.many_partner && row.is_expire == '1'"
				label="跟进已到期"
				content="达人已满足自动流转回团队公海，其余商务可认领达人"
			></tooltip>
			<popover @refresh="refresh" :row="row" v-if="!['0', '2'].includes(row.is_effective) && !$isSp(row.platform_id)"></popover>
		</talent-info>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import tooltip from '../../../components/tooltip';
import talentInfo from '../../../components/talentInfo';
import popover from '@/views/talentCRM/myTalent/components/popover';
export default {
	components: {
		tooltip,
		talentInfo,
		popover,
	},
	mixins: [mixin],
	inject: ['refresh'],
};
</script>
<style lang="less" scoped>
.expire {
	font-size: 12px;
	color: #fa8f14;

	::v-deep .icon-a-help-circle-obangzhu-xian {
		font-size: 12px;
		color: #fa8f14;
	}
}
</style>
